var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mbe-bread-crumb-new',{attrs:{"navigation-key":"pickups"}}),_c('pickups-search',{attrs:{"show-selectors":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }